import {
  TPersonalDataGetApplicationsRevokeFormResponse,
  TPersonalDataGetApplicationsSubmitFormResponse,
  TPersonalDataApplicationsStore,
} from '~/store/processing-personal/types.ts';
import { PayloadAction } from '@reduxjs/toolkit';

export const getApplicationFormFulfilled = (
  state: TPersonalDataApplicationsStore,
  action: PayloadAction<
    TPersonalDataGetApplicationsSubmitFormResponse | TPersonalDataGetApplicationsRevokeFormResponse
  >
) => {
  state.formData = action.payload;

  state.loading = false;
  state.error = null;
  state.status = '';
};

export const getApplicationFormPending = (state: TPersonalDataApplicationsStore) => {
  state.formData = null;
  state.loading = true;
};
